import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=02fad40c&scoped=true"
import script from "./VideoButton.vue?vue&type=script&lang=js"
export * from "./VideoButton.vue?vue&type=script&lang=js"
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=02fad40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fad40c",
  null
  
)

export default component.exports